// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-library__main-content[data-v-713b127e] {\n  min-height: 300px;\n  max-height: 450px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}", ""]);
// Exports
module.exports = exports;
